// extracted by mini-css-extract-plugin
export default {"document":"z6iqjW","message":"dZAqkd"};